/**
 * Avatar paths, the size cap and the URL allowlist. No Cloudflare bindings,
 * so the client can share the rules with the Worker.
 */

export const MAX_AVATAR_BYTES = 5 * 1024 * 1024;
export const AVATAR_PX = 256;

const USER_ID = /^[\w-]{1,128}$/;
const STORED_PATH = /^\/api\/account\/avatar\/[\w-]{1,128}$/;

export function isAvatarUserId(userId: string) {
  return USER_ID.test(userId);
}

export function avatarObjectKey(userId: string) {
  return `avatars/${userId}`;
}

export function avatarPublicPath(userId: string) {
  return `/api/account/avatar/${userId}`;
}

/**
 * Only our Worker-served path or an https photo. Anything else, including
 * `javascript:`, falls back to initials.
 */
export function avatarSrc(
  image: string | null | undefined,
  version?: Date | string | number | null,
): string | null {
  if (!image) return null;
  const trimmed = image.trim();
  if (STORED_PATH.test(trimmed)) {
    if (version == null || version === "") return trimmed;
    const stamp = version instanceof Date ? String(version.valueOf()) : String(version);
    return `${trimmed}?v=${encodeURIComponent(stamp)}`;
  }
  if (trimmed.startsWith("https://")) return trimmed;
  return null;
}
